import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-14 md:py-20">
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
          用户口碑
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          来自读者、从业者和爱好者的真实声音
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-7xl mx-auto px-4 md:px-6">
        {testimonials.map((t) => (
          <div
            key={t.id}
            className="bg-background-50 rounded-lg border border-background-200/60 p-6 flex flex-col"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">
                  {t.name}
                </p>
                <p className="text-xs text-foreground-400">
                  {t.role}
                </p>
              </div>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed flex-1">
              {t.content}
            </p>
            <div className="flex items-center gap-1 mt-4 text-accent-500">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-xs"></i>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}